(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const tickets = svs.tickets;
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useCallback = _React.useCallback;
const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const ImageMemo = tickets.next.components.ImageMemo;
const tracking = svs.ticketgames.ticketUtility.utils.tracking;
const _tickets$next$compone = tickets.next.components.ticketCarousel.selection,
  getCarouselImageSourceKey = _tickets$next$compone.getCarouselImageSourceKey,
  getImageSource = _tickets$next$compone.getImageSource,
  getTicketImage = _tickets$next$compone.getTicketImage;
const _tickets$next$compone2 = tickets.next.components.ticketCarousel.layout,
  createCarouselItems = _tickets$next$compone2.createCarouselItems,
  createCarouselShadowStates = _tickets$next$compone2.createCarouselShadowStates,
  getDesktopArrowOffset = _tickets$next$compone2.getDesktopArrowOffset,
  getDesktopVisibleSideCount = _tickets$next$compone2.getDesktopVisibleSideCount,
  getIntroItemLayout = _tickets$next$compone2.getIntroItemLayout;
const useCarouselIntro = tickets.next.components.ticketCarousel.useCarouselIntro;
const useCarouselMotion = tickets.next.components.ticketCarousel.useTicketCarouselMotion;
const useCarouselViewport = tickets.next.components.ticketCarousel.useCarouselViewport;
const PriceLabel = tickets.next.components.nova.PriceLabel;
const PriceLabelCurrency = tickets.next.components.nova.PriceLabelCurrency;
const Callout = tickets.next.components.nova.Callout;
const MAX_PODIUM_OPACITY = 0.7;
const FLIP_MIN_SCALE = 0.5;
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const getElementHeight = selector => {
  if (typeof document === 'undefined') {
    return 0;
  }
  const element = document.querySelector(selector);
  return (element === null || element === void 0 ? void 0 : element.getBoundingClientRect().height) || 0;
};
const getBottomSheetHeight = () => getElementHeight('.triss-next-pick-bottom-sheet');
const getTopNavHeight = () => getElementHeight('.navigation-back-next-lobby') + getElementHeight('.js-fixed-top-content');
const getCarouselCenterY = viewportHeight => {
  if (typeof document === 'undefined') {
    return viewportHeight / 2;
  }
  const carousel = document.querySelector('.ticket-carousel');
  const carouselRect = carousel === null || carousel === void 0 ? void 0 : carousel.getBoundingClientRect();
  return carouselRect ? carouselRect.top + carouselRect.height / 2 : viewportHeight / 2;
};
const getFlippedTicketLayout = item => {
  var _document$documentEle, _document$documentEle2;
  if (!(item !== null && item !== void 0 && item.width) || !(item !== null && item !== void 0 && item.height) || typeof window === 'undefined') {
    return {
      scale: 1,
      offsetY: 0
    };
  }
  if (svs.core.detect.breakpoint.greaterThan('am')) {
    return {
      scale: 1,
      offsetY: 0
    };
  }
  const viewportHeight = window.innerHeight || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientHeight) || 0;
  const viewportWidth = window.innerWidth || ((_document$documentEle2 = document.documentElement) === null || _document$documentEle2 === void 0 ? void 0 : _document$documentEle2.clientWidth) || 0;
  const topNavHeight = getTopNavHeight();
  const availableHeight = Math.max(0, viewportHeight - topNavHeight - getBottomSheetHeight());
  const scaleByHeight = availableHeight > 0 ? availableHeight / item.height : 1;
  const scaleByWidth = viewportWidth > 0 ? viewportWidth / item.width : 1;
  const scale = Math.max(FLIP_MIN_SCALE, Math.min(scaleByHeight, scaleByWidth));
  const availableCenterY = topNavHeight + availableHeight / 2;
  const offsetY = availableCenterY - getCarouselCenterY(viewportHeight);
  return {
    scale,
    offsetY
  };
};
const getCenteredOpacity = _ref => {
  let items = _ref.items,
    panelWidth = _ref.panelWidth;
  if (!(items !== null && items !== void 0 && items.length) || !panelWidth) {
    return MAX_PODIUM_OPACITY;
  }
  const closestDistanceFromCenter = items.reduce((closestDistance, item) => {
    const itemDistance = Math.abs((item === null || item === void 0 ? void 0 : item.x) || 0);
    return Math.min(closestDistance, itemDistance);
  }, Number.POSITIVE_INFINITY);
  const fadeDistance = Math.max(panelWidth * 0.5, 1);
  const centeredRatio = clamp(1 - closestDistanceFromCenter / fadeDistance, 0, 1);
  return centeredRatio * MAX_PODIUM_OPACITY;
};
const getPickExitItemLayout = _ref2 => {
  let isDesktop = _ref2.isDesktop,
    item = _ref2.item,
    pickExitNumber = _ref2.pickExitNumber;
  if (!pickExitNumber || item.number === pickExitNumber) {
    return item;
  }
  const direction = item.direction || (item.offset < 0 ? -1 : 1);
  const exitDistance = item.width * (isDesktop ? 0.72 : 0.82);
  return _objectSpread(_objectSpread({}, item), {}, {
    boxShadow: 'none',
    opacity: 0,
    scale: item.scale * 0.96,
    x: item.x + direction * exitDistance,
    y: item.y + (isDesktop ? item.height * 0.02 : 0)
  });
};
const getNormalizedBackImage = backImage => {
  const backImageData = (backImage === null || backImage === void 0 ? void 0 : backImage.image) || backImage;
  if (!backImageData) {
    return null;
  }
  return typeof backImageData === 'string' ? {
    src: backImageData
  } : backImageData;
};
const stopCarouselEvent = event => {
  event.stopPropagation();
};
const usePriceLabelSize = function () {
  let map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    xs: 'lg'
  };
  const breakpoint = svs.tickets.next.hooks.useBreakpoints();
  return map[breakpoint] || 'lg';
};
const TicketCarouselBackFace = _ref3 => {
  let image = _ref3.image,
    ticketName = _ref3.ticketName,
    ticketWidth = _ref3.ticketWidth,
    ticketHeight = _ref3.ticketHeight;
  const ticketNameStyle = tickets.next.utils.utils.getTicketNameStyle(ticketWidth, ticketHeight);
  return React.createElement("div", {
    className: "next-play-card__back-surface f-body",
    onClick: stopCarouselEvent,
    onPointerCancel: stopCarouselEvent,
    onPointerDown: stopCarouselEvent,
    onPointerMove: stopCarouselEvent,
    onPointerUp: stopCarouselEvent
  }, React.createElement(ImageMemo, {
    cssSelectors: "next-play-card__back-image",
    image: _objectSpread(_objectSpread({}, image), {}, {
      altText: (image === null || image === void 0 ? void 0 : image.altText) || 'Baksida av lott'
    })
  }), ticketName && React.createElement("h3", {
    className: "h3 ticket-id-popper--back",
    style: ticketNameStyle
  }, ticketName));
};
const TicketCarouselArrow = _ref4 => {
  let direction = _ref4.direction,
    isVisible = _ref4.isVisible,
    onMove = _ref4.onMove,
    panelWidth = _ref4.panelWidth,
    viewportWidth = _ref4.viewportWidth,
    visibleSideCount = _ref4.visibleSideCount;
  if (!isVisible) {
    return null;
  }
  const left = direction < 0;
  const arrowOffset = getDesktopArrowOffset({
    panelWidth,
    viewportWidth,
    visibleSideCount
  });
  return React.createElement("button", {
    "aria-label": left ? 'Visa förra lotten' : 'Visa nästa lotten',
    className: "qa-ticket-carousel-arrow-".concat(left ? 'left' : 'right', " ticket-carousel__arrow ticket-carousel__arrow--").concat(left ? 'left' : 'right'),
    onClick: event => {
      event.stopPropagation();
      if (event.detail === 0) {
        onMove(direction);
      }
    },
    onPointerDown: event => {
      event.stopPropagation();
      onMove(direction);
    },
    style: {
      left: "calc(50% ".concat(left ? '-' : '+', " ").concat(arrowOffset, "px)")
    },
    type: "button"
  }, React.createElement(Icon, {
    icon: left ? 'menu-left' : 'menu-right',
    size: "100"
  }));
};
const TicketCarouselFlipButton = _ref5 => {
  let _ref5$flippedScale = _ref5.flippedScale,
    flippedScale = _ref5$flippedScale === void 0 ? 1 : _ref5$flippedScale,
    isFlipped = _ref5.isFlipped,
    onClick = _ref5.onClick;
  return React.createElement(IconButton, {
    "aria-label": isFlipped ? 'Visa framsida av lott' : 'Vända lott',
    className: "ts-top-bar-game-color ts-next-topbar-icon-btn qa-ticket-carousel-flip ticket-carousel__flip",
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    },
    onPointerDown: stopCarouselEvent,
    onPointerUp: stopCarouselEvent,
    style: {
      width: '24px',
      height: '24px',
      transform: "scale(".concat(1 / flippedScale, ")"),
      transformOrigin: 'top right'
    }
  }, React.createElement(Icon, {
    icon: isFlipped ? 'close' : 'information',
    size: "100"
  }));
};
const TicketCarouselItem = _ref6 => {
  let backImage = _ref6.backImage,
    cssSelectors = _ref6.cssSelectors,
    image = _ref6.image,
    imageAltText = _ref6.imageAltText,
    isDesktop = _ref6.isDesktop,
    isFlipped = _ref6.isFlipped,
    item = _ref6.item,
    onCenterClick = _ref6.onCenterClick,
    onFlipClick = _ref6.onFlipClick,
    onItemClick = _ref6.onItemClick,
    onPick = _ref6.onPick,
    ticketCallout = _ref6.ticketCallout,
    ticketName = _ref6.ticketName,
    ticketPrice = _ref6.ticketPrice;
  const framedCssSelectors = cssSelectors ? "".concat(cssSelectors, " ticket-with-podium-image--framed") : 'ticket-with-podium-image--framed';
  const canFlip = item.isSelected && Boolean(backImage);
  const cardHostClassName = "next-play-card-host ticket-carousel__card-host".concat(isFlipped ? ' next-play-card-host--flipped' : '');
  const _ref7 = isFlipped ? getFlippedTicketLayout(item) : {
      scale: 1,
      offsetY: 0
    },
    flippedScale = _ref7.scale,
    flippedOffsetY = _ref7.offsetY;
  const visualScale = item.scale * flippedScale;
  const carouselStageScale = isDesktop ? 0.96 : 0.94;
  const numberScale = 1 / (visualScale * carouselStageScale);
  const priceLabelSize = usePriceLabelSize();
  return React.createElement("div", {
    "aria-hidden": !item.isSelected,
    className: "ticket-carousel__item ".concat(item.isSelected ? 'ticket-carousel__item--selected' : '').concat(isFlipped ? ' ticket-carousel__item--flipped' : ''),
    "data-ticket-carousel-number": item.number,
    "data-ticket-carousel-selected": item.isSelected ? 'true' : 'false',
    onClick: !item.isSelected && onItemClick ? event => onItemClick(event, item.number) : undefined,
    style: {
      width: "".concat(item.width, "px"),
      height: "".concat(item.height, "px"),
      zIndex: isFlipped ? 320 : item.zIndex,
      opacity: item.opacity,
      boxShadow: item.boxShadow,
      transform: "translate3d(calc(-50% + ".concat(item.x, "px), calc(-50% + ").concat(item.y + flippedOffsetY, "px), 0) scale(").concat(visualScale, ")")
    }
  }, React.createElement("div", {
    className: "ticket-carousel__card"
  }, React.createElement("div", {
    className: cardHostClassName
  }, React.createElement("div", {
    "aria-hidden": isFlipped,
    className: "next-play-card-front-layer"
  }, React.createElement(ImageMemo, {
    cssSelectors: framedCssSelectors,
    image: _objectSpread(_objectSpread({}, image), {}, {
      altText: "".concat(imageAltText, " ").concat(item.number)
    })
  })), canFlip && React.createElement("div", {
    "aria-hidden": !isFlipped,
    className: "next-play-card-back-layer"
  }, React.createElement(TicketCarouselBackFace, {
    image: backImage,
    ticketHeight: item.height,
    ticketName: ticketName,
    ticketWidth: item.width
  }))), canFlip && React.createElement(TicketCarouselFlipButton, {
    flippedScale: flippedScale,
    isFlipped: isFlipped,
    onClick: onFlipClick
  }), Boolean(item.isSelected && onPick && !isFlipped) && React.createElement("button", {
    "aria-label": "Valj lott ".concat(item.number),
    className: "qa-ticket-carousel-pick ticket-carousel__pick",
    onClick: event => onCenterClick(event, item.number),
    type: "button"
  }, React.createElement("span", {
    className: "ticket-carousel__sr-only"
  }, "Valj lott ", item.number))), !isFlipped && React.createElement("div", {
    "aria-hidden": "true",
    className: "ticket-carousel__number ticket-carousel__number--fixed-size",
    style: {
      transform: "scale(".concat(numberScale, ")"),
      transformOrigin: 'top left'
    }
  }, item.number), !isFlipped && item.isSelected && ticketPrice && React.createElement(PriceLabel, {
    className: "u-position-absolute tickets-next-pick-price-label",
    edge: "trailing",
    size: priceLabelSize,
    variant: "primary"
  }, React.createElement(PriceLabelCurrency, {
    price: ticketPrice
  })), !isFlipped && item.isSelected && React.createElement(Callout, {
    "aria-hidden": "true",
    className: "tickets-next-pick-callout",
    label: ticketCallout
  }));
};
const TicketCarousel = _ref8 => {
  let _ref8$animatePicking = _ref8.animatePicking,
    animatePicking = _ref8$animatePicking === void 0 ? false : _ref8$animatePicking,
    _ref8$availableWidth = _ref8.availableWidth,
    availableWidth = _ref8$availableWidth === void 0 ? 0 : _ref8$availableWidth,
    backImage = _ref8.backImage,
    image = _ref8.image,
    initialSelectedNumber = _ref8.initialSelectedNumber,
    cssSelectors = _ref8.cssSelectors,
    ticketName = _ref8.ticketName,
    ticketCallout = _ref8.ticketCallout,
    ticketType = _ref8.ticketType,
    ticketPrice = _ref8.ticketPrice,
    skins = _ref8.skins,
    variations = _ref8.variations,
    onPick = _ref8.onPick,
    onSelectedNumberChange = _ref8.onSelectedNumberChange,
    onShadowStatesChange = _ref8.onShadowStatesChange,
    onPodiumOpacityChange = _ref8.onPodiumOpacityChange,
    frameMetrics = _ref8.frameMetrics,
    _ref8$panelWidth = _ref8.panelWidth,
    panelWidth = _ref8$panelWidth === void 0 ? 0 : _ref8$panelWidth,
    _ref8$panelHeight = _ref8.panelHeight,
    panelHeight = _ref8$panelHeight === void 0 ? 0 : _ref8$panelHeight,
    _ref8$panelLiftPx = _ref8.panelLiftPx,
    panelLiftPx = _ref8$panelLiftPx === void 0 ? 0 : _ref8$panelLiftPx,
    _ref8$surfaceWidth = _ref8.surfaceWidth,
    surfaceWidth = _ref8$surfaceWidth === void 0 ? 0 : _ref8$surfaceWidth,
    _ref8$surfaceHeight = _ref8.surfaceHeight,
    surfaceHeight = _ref8$surfaceHeight === void 0 ? 0 : _ref8$surfaceHeight;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSelectedTicketFlipped = _useState2[0],
    setIsSelectedTicketFlipped = _useState2[1];
  const safePanelWidth = Math.max(panelWidth, 1);
  const safePanelHeight = Math.max(panelHeight, 1);
  const _useCarouselViewport = useCarouselViewport(),
    isDesktop = _useCarouselViewport.isDesktop,
    viewportWidth = _useCarouselViewport.viewportWidth;
  const arrowAvailableWidth = availableWidth || viewportWidth;
  const isPickExiting = Boolean(animatePicking);
  const isCarouselDisabled = isPickExiting || isSelectedTicketFlipped;
  const imageSource = useMemo(() => getCarouselImageSourceKey({
    image,
    skins,
    variations
  }), [image, skins, variations]);
  const normalizedBackImage = useMemo(() => getNormalizedBackImage(backImage), [backImage]);
  const backImageSource = getImageSource(normalizedBackImage || {});
  const ticketTitle = ticketName || ticketType;
  const imageAltText = (image === null || image === void 0 ? void 0 : image.altText) || ticketTitle || 'Ticket';
  const visibleSideCount = useMemo(() => getDesktopVisibleSideCount({
    isDesktop,
    viewportWidth
  }), [isDesktop, viewportWidth]);
  const _useCarouselIntro = useCarouselIntro({
      imageSource,
      isDesktop
    }),
    finishIntro = _useCarouselIntro.finishIntro,
    introProgress = _useCarouselIntro.introProgress;
  const handleFlipSelectedTicket = useCallback(() => {
    setIsSelectedTicketFlipped(previousValue => !previousValue);
    const trackingLabel = tracking.createTopBarTrackingLabel({
      location: 'valja',
      gameCode: ticketType
    });
    tracking.trackTopBarAction('Vänd_lott', trackingLabel);
  }, []);
  const _useCarouselMotion = useCarouselMotion({
      finishIntro,
      imageSource,
      initialSelectedNumber,
      onPick: onPick && !isSelectedTicketFlipped ? onPick : undefined,
      onSelectedNumberChange
    }),
    handleCenterClick = _useCarouselMotion.handleCenterClick,
    handleItemClick = _useCarouselMotion.handleItemClick,
    handleKeyDown = _useCarouselMotion.handleKeyDown,
    handlePointerCancel = _useCarouselMotion.handlePointerCancel,
    handlePointerDown = _useCarouselMotion.handlePointerDown,
    handlePointerMove = _useCarouselMotion.handlePointerMove,
    handlePointerUp = _useCarouselMotion.handlePointerUp,
    isDragging = _useCarouselMotion.isDragging,
    moveBy = _useCarouselMotion.moveBy,
    position = _useCarouselMotion.position,
    selectedNumber = _useCarouselMotion.selectedNumber;
  const carouselItems = useMemo(() => createCarouselItems({
    isDesktop,
    panelHeight: safePanelHeight,
    panelWidth: safePanelWidth,
    position,
    visibleSideCount
  }), [isDesktop, position, safePanelHeight, safePanelWidth, visibleSideCount]);
  const displayedCarouselItems = useMemo(() => carouselItems.map(item => getIntroItemLayout({
    isDesktop,
    item,
    progress: introProgress
  })), [carouselItems, isDesktop, introProgress]);
  const renderedCarouselItems = useMemo(() => displayedCarouselItems.map(item => getPickExitItemLayout({
    isDesktop,
    item,
    pickExitNumber: animatePicking ? selectedNumber : null
  })), [displayedCarouselItems, isDesktop, animatePicking, selectedNumber]);
  const podiumOpacity = useMemo(() => getCenteredOpacity({
    items: renderedCarouselItems,
    panelWidth: safePanelWidth
  }), [renderedCarouselItems, safePanelWidth]);
  const shadowStates = useMemo(() => createCarouselShadowStates({
    frameMetrics,
    items: renderedCarouselItems,
    panelLiftPx,
    panelWidth: safePanelWidth,
    surfaceHeight,
    surfaceWidth
  }), [frameMetrics, panelLiftPx, renderedCarouselItems, safePanelWidth, surfaceHeight, surfaceWidth]);
  useEffect(() => {
    if (onShadowStatesChange) {
      onShadowStatesChange(shadowStates);
    }
  }, [onShadowStatesChange, shadowStates]);
  useEffect(() => {
    if (onPodiumOpacityChange) {
      onPodiumOpacityChange(podiumOpacity);
    }
  }, [onPodiumOpacityChange, podiumOpacity]);
  useEffect(() => {
    setIsSelectedTicketFlipped(false);
  }, [backImageSource, imageSource, selectedNumber]);
  useEffect(() => () => {
    if (onShadowStatesChange) {
      onShadowStatesChange([]);
    }
  }, [onShadowStatesChange]);
  return React.createElement("div", {
    "aria-disabled": isCarouselDisabled,
    "aria-label": ticketTitle ? "".concat(ticketTitle, " carousel") : 'Ticket carousel',
    "aria-roledescription": "carousel",
    className: [cssSelectors, 'ticket-carousel', 'ticket-carousel--draggable', isDesktop ? 'ticket-carousel--desktop' : 'ticket-carousel--mobile', isDragging ? 'ticket-carousel--dragging' : undefined, isPickExiting ? 'ticket-carousel--picking' : undefined, isSelectedTicketFlipped ? 'ticket-carousel--flipped' : undefined].filter(Boolean).join(' '),
    "data-selected-ticket": selectedNumber,
    draggable: false,
    onDragStart: event => event.preventDefault(),
    onKeyDown: isCarouselDisabled ? undefined : handleKeyDown,
    onPointerCancel: isCarouselDisabled ? undefined : handlePointerCancel,
    onPointerDown: isCarouselDisabled ? undefined : handlePointerDown,
    onPointerMove: isCarouselDisabled ? undefined : handlePointerMove,
    onPointerUp: isCarouselDisabled ? undefined : handlePointerUp,
    role: "group",
    tabIndex: isCarouselDisabled ? -1 : 0
  }, React.createElement("div", {
    className: "ticket-carousel__track"
  }, renderedCarouselItems.map(item => React.createElement(TicketCarouselItem, {
    backImage: normalizedBackImage,
    cssSelectors: cssSelectors,
    image: getTicketImage({
      image,
      skins,
      ticketNumber: item.number,
      variations
    }),
    imageAltText: imageAltText,
    isDesktop: isDesktop,
    isFlipped: isSelectedTicketFlipped && item.isSelected,
    item: item,
    key: item.key,
    onCenterClick: handleCenterClick,
    onFlipClick: handleFlipSelectedTicket,
    onItemClick: isCarouselDisabled ? undefined : handleItemClick,
    onPick: onPick,
    ticketCallout: ticketCallout,
    ticketName: ticketName,
    ticketPrice: ticketPrice
  }))), React.createElement(TicketCarouselArrow, {
    direction: -1,
    isVisible: isDesktop && !isPickExiting && !isSelectedTicketFlipped,
    onMove: moveBy,
    panelWidth: safePanelWidth,
    viewportWidth: arrowAvailableWidth,
    visibleSideCount: visibleSideCount
  }), React.createElement(TicketCarouselArrow, {
    direction: 1,
    isVisible: isDesktop && !isPickExiting && !isSelectedTicketFlipped,
    onMove: moveBy,
    panelWidth: safePanelWidth,
    viewportWidth: arrowAvailableWidth,
    visibleSideCount: visibleSideCount
  }));
};
setGlobal('svs.tickets.next.components.ticketCarousel.TicketCarousel', TicketCarousel);

 })(window);